import { AddEmployeeUserDTO, EmployeeFormFields } from 'types';
import { parseEmployeeAddFormDataIntoEmployeeUpdateDTO } from './parseEmployeeAddFormDataIntoEmployeeUpdateDTO';

export const parseEmployeeAddFormDataIntoEmployeeCreateDTO: (
    employee: EmployeeFormFields,
) => AddEmployeeUserDTO = (employee) => ({
    ...parseEmployeeAddFormDataIntoEmployeeUpdateDTO(employee),
});
